<template>
  <RouterLink
    :to="`/blogs/${blog?.slug}`"
    class="relative flex flex-col w-full group"
  >
    <div class="rounded-xl overflow-hidden">
      <img
        :src="blog?.cover"
        :alt="title"
        class="z-10 w-full h-full object-cover"
      />
    </div>
    <div class="relative flex flex-col w-full h-full z-20 bg-white pt-6 flex-1">
      <h3
        class="text-lg leading-[22px] text-dark font-semibold mb-4 transition-300 group-hover:text-green"
      >
        {{ blog?.title }}
      </h3>
      <p class="mt-auto text-xs text-gray">
        {{ dayjs(blog?.created_at).format("LL") }}
      </p>
    </div>
  </RouterLink>
</template>

<script setup lang="ts">
import dayjs from "dayjs";

interface BlogSingle {
  blog: {
    id: number;
    title: string;
    slug: string;
    cover: string;
    status: string;
    view_count: number;
  };
}
defineProps<BlogSingle>();
</script>

<style scoped></style>
